var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MetricTotal',_vm._b({attrs:{"title":_vm.title,"item-id":_vm.itemId,"entity":_vm.entity,"operation":_vm.operation,"owner-posts":true}},'MetricTotal',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }